export function getUrlWithProfilePicture(inputString: string | null) {
    if (inputString) {
        if (
            inputString?.includes("http://") ||
            inputString?.includes("https://")
        ) {
            return inputString;
        } else {
            return `${import.meta.env.VITE_BASE_URL}/${inputString}`;
        }
    }
    else {
        return "/profile_pic_placeholder.jpg"
    }
}
